<script setup>
import { inject, computed } from 'vue'
import { title } from 'radash'

defineProps({
  item: {
    type: Object,
    required: true
  }
})

const checkSubscription = inject('checkSubscription')

const emojiByValue = computed(() =>
  new Map([
    ['single', '🌟'], // solo star = happily solo
    ['in_a_relationship', '❤️'], // classic heart
    ['engaged', '💍'], // ring
    ['married', '💒'], // wedding chapel
    ['its_complicated', '🌀'], // tangled/complex
    ['in_an_open_relationship', '♾️'], // infinity (open/non-exclusive)
    ['separated', '⏸️'], // on pause
    ['divorced', '💔'], // broken heart
    ['widowed', '🕯️'], // candle/remembrance
    ['dating', '🥂'], // clinking glasses
    ['committed', '🤝'], // handshake/commitment
    ['long_distance_relationship', '💌'] // love across distance
  ])
)
</script>

<template>
  <div
    class="flex gap-1 items-center"
    :class="{ 'blur-md select-none py-2': checkSubscription(item) }">
    <span v-if="item.value && emojiByValue.get(item.value)">
      {{ emojiByValue.get(item.value) }}
    </span>

    <span class="text-sm text-gray-500 not-italic capitalize">
      {{ checkSubscription(item) ? 'Secret text' : title(item.value) }}
    </span>
  </div>
</template>